import { useIsDynamicEmsAccessible } from 'src/Libs/dynamic-power-prices'
import { FeatureElements } from '../feature-versioning'

interface ReturnType {
  systemSettingsElementKeys: FeatureElements[]
  smartFunctionsElementKeys: FeatureElements[]
}

/**
 * This hook return dynamic elements keys for the system settings. Element keys are used to determine if a feature has new content.
 */
const useDynamicSystemSettingsElementKeys = (): ReturnType => {
  const { isDynamicEmsAccessible } = useIsDynamicEmsAccessible()
  const systemSettingsElementKeys = [
    FeatureElements.PropertiesSideBarElement,
    FeatureElements.PropertySolarSideBarElement,
    FeatureElements.PropertyBatterySideBarElement,
    FeatureElements.PropertyPowermeterSideBarElement,
    FeatureElements.PropertyWallboxSideBarElement,
    FeatureElements.PropertySmartFunctionSideBarElement,
    FeatureElements.PropertyEmergencyPowerSideBarElement,
    FeatureElements.PropertyInstallationSideBarElement,
  ]
  const smartFunctionsElementKeys = [FeatureElements.PropertySmartFunctionSideBarElement]

  if (isDynamicEmsAccessible) {
    systemSettingsElementKeys.push(FeatureElements.PropertySmartFunctionsDynamicEmsFeature)
    smartFunctionsElementKeys.push(FeatureElements.PropertySmartFunctionsDynamicEmsFeature)
  }

  return { systemSettingsElementKeys, smartFunctionsElementKeys }
}

export default useDynamicSystemSettingsElementKeys
